import * as React from 'react';
import { Card, Box } from "@mui/material";
import { CommonInputProps } from 'react-admin';
import { CreateTitle, EditTitle } from './Title';

type EditComponentProps = {
    children?: JSX.Element,
    attributes: string[],
    title?: JSX.Element,
    actions?: JSX.Element
}

export type CustomComponentProps = {
    children?: JSX.Element
}

export function EditComponent(props: EditComponentProps) {
    const { children, actions, attributes, title } = props;
    return (
        <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" flexDirection="row" justifyContent="space-between" sx={{paddingBottom: '10px'}}>
                {title ?? <EditTitle attributes={attributes} />}
                {actions}
            </Box>
            
            <Card sx={{ width: "100%" }}>
                {children}
            </Card>
        </Box>
    );
}

type CreateComponentProps = {
    children?: JSX.Element,
    source: string,
    title?: JSX.Element,
    actions?: JSX.Element
}

export function CreateComponent(props: CreateComponentProps) {
    const { children, actions, source, title } = props;
    return (
        <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" flexDirection="row" justifyContent="space-between" sx={{paddingBottom: '10px'}}>
                {title ?? <CreateTitle source={source} />}
                {actions}
            </Box>
            
            <Card sx={{ width: "100%" }}>
                {children}
            </Card>
        </Box>
    );
}
